import { capitalize } from "../../components/Utils/Commons";

interface AuditRow {
    oldValues: Record<string, unknown>;
    newValues?: Record<string, unknown> | null;
}

export interface LastChange {
    old: unknown;
    current: unknown;
}

// A row that audits an addition carries no old side and a deletion carries no new side: both read as empty text.
export const lastChangeFromAudits = (audits: AuditRow[] | null | undefined, field: string): LastChange | null => {
    const fieldName = capitalize(field, false, ".");

    const audit = audits?.find(x => x.oldValues[fieldName] !== undefined);
    if (!audit) return null;

    return {
        old: audit.oldValues[fieldName] ?? "",
        current: audit.newValues?.[fieldName] ?? "",
    };
};
